import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { makeRequest } from '@finam/txservices-core/request';
import { pipeCancelablePromise } from '@finam/txservices-core/promise';
import { AccessApiClient, RequestRegistrationConfirmationRequest, ConfirmEmailRequest, CheckLoginInUseRequest, RequestRestoreAccessRequest, CheckRestoreAccessRequest, ConfirmRestoreAccessRequest, VerifyAccountRequest } from './proto';

var EdoxAccessService = /*#__PURE__*/function () {
  function EdoxAccessService(hosts, tokenProvider) {
    _classCallCheck(this, EdoxAccessService);

    this.request = makeRequest({
      hosts: hosts,
      tokenProvider: tokenProvider
    });
    this.requestNoAuth = makeRequest({
      hosts: hosts
    });
  }

  _createClass(EdoxAccessService, [{
    key: "getRegistrationInfo",
    value: function getRegistrationInfo(request) {
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:getRegistrationInfo',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).getRegistrationInfo(request);
        }
      });
    }
  }, {
    key: "requestRestoreAccess",
    value: function requestRestoreAccess(userId) {
      var request = RequestRestoreAccessRequest.create({
        userId: userId
      });
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:requestRestoreAccess',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).requestRestoreAccess(request);
        }
      });
    }
  }, {
    key: "checkRestoreAccess",
    value: function checkRestoreAccess(token) {
      var request = CheckRestoreAccessRequest.create({
        token: token
      });
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:checkRestoreAccess',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).checkRestoreAccess(request);
        }
      });
    }
  }, {
    key: "confirmRestoreAccess",
    value: function confirmRestoreAccess(token) {
      var request = ConfirmRestoreAccessRequest.create({
        token: token
      });
      var promise = this.requestNoAuth.unary({
        log: 'EdoxAccess:confirmRestoreAccess',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).confirmRestoreAccess(request);
        }
      });
      return pipeCancelablePromise(promise, function (res) {
        return res.maskedPhone;
      });
    }
  }, {
    key: "restoreAccess",
    value: function restoreAccess(request) {
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:restoreAccess',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).restoreAccess(request);
        }
      });
    }
  }, {
    key: "checkAccountRegistration",
    value: function checkAccountRegistration(request) {
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:checkAccountRegistration',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).checkAccountRegistration(request);
        }
      });
    }
  }, {
    key: "registerAccount",
    value: function registerAccount(request) {
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:registerAccount',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).registerAccount(request);
        }
      });
    }
  }, {
    key: "confirmRegistration",
    value: function confirmRegistration(request) {
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:confirmRegistration',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).confirmRegistration(request);
        }
      });
    }
  }, {
    key: "requestRegistrationConfirmation",
    value: function requestRegistrationConfirmation(authId) {
      var request = RequestRegistrationConfirmationRequest.create({
        authId: authId
      });
      return this.requestNoAuth.unary({
        log: 'EdoxAccess:requestRegistrationConfirmation',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).requestRegistrationConfirmation(request);
        }
      });
    }
  }, {
    key: "requestEmailConfirmation",
    value: function requestEmailConfirmation(request) {
      return this.request.unary({
        log: 'EdoxAccess:requestEmailConfirmation',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).requestEmailConfirmation(request);
        }
      });
    }
  }, {
    key: "confirmEmail",
    value: function confirmEmail(token) {
      var request = ConfirmEmailRequest.create({
        token: token
      });
      return this.request.unary({
        log: 'EdoxAccess:confirmEmail',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).confirmEmail(request);
        }
      });
    }
  }, {
    key: "changeLogin",
    value: function changeLogin(request) {
      return this.request.unary({
        log: 'EdoxAccess:changeLogin',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).changeLogin(request);
        }
      });
    }
  }, {
    key: "checkLoginInUse",
    value: function checkLoginInUse(login) {
      var request = CheckLoginInUseRequest.create({
        login: login
      });
      var promise = this.request.unary({
        log: 'EdoxAccess:checkLoginInUse',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).checkLoginInUse(request);
        }
      });
      return pipeCancelablePromise(promise, function (res) {
        return res.inUse;
      });
    }
  }, {
    key: "changePassword",
    value: function changePassword(request) {
      return this.request.unary({
        log: 'EdoxAccess:changePassword',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).changePassword(request);
        }
      });
    }
  }, {
    key: "verifyAccount",
    value: function verifyAccount() {
      var request = VerifyAccountRequest.create();
      return this.request.unary({
        log: 'EdoxAccess:verifyAccount',
        handler: function handler(transport, logRequest) {
          logRequest(request);
          return new AccessApiClient(transport).verifyAccount(request);
        }
      });
    }
  }]);

  return EdoxAccessService;
}();

export { EdoxAccessService as default };